import React, { useState, useEffect } from "react";
import { Panel, PanelHeader, PanelBody, PanelFooter } from "../../components/panel/panel.jsx";

import Select from "react-select";
import api from "../../config/axiosConfig.js";

import { useTipoContingencia } from "../../hooks_cache/useTipoContingencias.js";
import SwitchContingencia from "./SwitchContingencia.jsx";

const initialFormData = {
  id_tipo_contingencia: null,
  motivoContingencia: "",
  fInicio: "",
  fFin: "",
};

const ContingenciaPanel = ({ MiEmpresa }) => {
  const [formData, setFormData] = useState(initialFormData);
  const [errores, setErrores] = useState({});

  const { data: tiposContingencia } = useTipoContingencia();

  useEffect(() => {
    fetchEventoContingencia();
  }, [MiEmpresa]);

  const fetchEventoContingencia = async () => {
    try {
      if (MiEmpresa.modoContingencia) {
        const { data } = await api.get(`/${MiEmpresa.id}/eventoContingencia/activo`);
        console.log(data);

        setFormData({
          id_tipo_contingencia: data.id_tipo_contingencia,
          motivoContingencia: data.motivoContingencia,
          fInicio: data.fInicio,
          fFin: data.fFin,
        });
      }
    } catch (error) {
      console.error("Error al obtener evento de contingencia activo:", error);
    }
  };

  const handleSelectChange = (selectedOption, { name }) => {
    setFormData((prev) => ({
      ...prev,
      [name]: selectedOption ? selectedOption.value : null,
    }));
  };

  const opcionesContingencia = tiposContingencia?.map((tc) => ({
    value: tc.id,
    label: `${tc.codigo} - ${tc.descripcion}`,
  }));

  const selectedContingencia = opcionesContingencia?.find((op) => op.value === formData.id_tipo_contingencia);
  return (
    <Panel>
      <PanelHeader noButton={true}>CONTINGENCIA</PanelHeader>
      <PanelBody>
        <div className="col-md-12">
          <div className="mb-3 mb-md-3">
            <label className="form-label">Tipo de Contingencia:</label>
            <Select
              name="id_tipo_contingencia"
              options={opcionesContingencia}
              value={selectedContingencia}
              isSearchable
              isClearable
              placeholder="Seleccione tipo de contingencia"
              onChange={handleSelectChange}
              isDisabled={MiEmpresa.modoContingencia}
            />
            {errores["id_tipo_contingencia"] && <p style={{ color: "red" }}>* {errores["id_tipo_contingencia"]}</p>}
          </div>
        </div>

        <div className={`col-md-12 mb-3`}>
          <div className="form-floating mb-3 mb-md-0">
            <input
              disabled={MiEmpresa.modoContingencia}
              type="text"
              className="form-control fs-15px"
              placeholder="Motivo de la contingencia"
              name="motivoContingencia"
              value={formData.motivoContingencia}
              onChange={(e) => setFormData({ ...formData, motivoContingencia: e.target.value })}
            />
            <label className="d-flex align-items-center fs-13px">Motivo de la contingencia</label>
          </div>
        </div>
      </PanelBody>

      <PanelFooter className="text-center border-1">
        <SwitchContingencia MiEmpresa={MiEmpresa} formData={formData} />
      </PanelFooter>
    </Panel>
  );
};

export default ContingenciaPanel;
